import apiClient from './client'

export interface LoginCredentials {
  email: string
  password: string
}

export interface RegisterData extends LoginCredentials {
  name?: string
}

export interface AuthResponse {
  user: {
    id: string
    email: string
    name: string | null
    plan: string
  }
  token: string
  refreshToken: string
  expiresIn: number
}

export const authApi = {
  login: (credentials: LoginCredentials): Promise<AuthResponse> =>
    apiClient.post('/auth/login', credentials),

  register: (data: RegisterData): Promise<AuthResponse> =>
    apiClient.post('/auth/register', data),

  logout: (): Promise<void> =>
    apiClient.post('/auth/logout'),

  getMe: (): Promise<{
    id: string
    email: string
    name: string | null
    avatar: string | null
    plan: string
  }> => apiClient.get('/auth/me'),

  refresh: (refreshToken: string): Promise<{ token: string; expiresIn: number }> =>
    apiClient.post('/auth/refresh', { refreshToken }),
}
